import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-prayer2',
  templateUrl: './prayer2.component.html',
  styleUrls: ['./prayer2.component.css']
})
export class Prayer2Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
